<header #headerBgDev class="headerBg col-12 pl-xl-5 pr-xl-5 pl-lg-5 pr-lg-5 pl-sm-3 pr-sm-3">

  <div class="headerLeft">
    <a (click)="logoClick()">
      <img class="headerLogo float-left mr-4" alt="Logo | ZEN-Classics" src="assets/images/logo.png" (click)="closeMyCart()">
    </a>

    <i class="fa fa-bars" [ngClass]="{'displayNone' : editOrderAddingAnotherItem}" (click)="showMenuDropDown = !showMenuDropDown; showLoginSignupDropDown = false; showDropDown = false; showSearchBar = false; closeMyCart()"></i>

    <ul class="nav float-left header-navigation" *ngIf="showMenuDropDown || showMenuBigDevice" [ngClass]="{'displayNone' : editOrderAddingAnotherItem}">
      <li class="nav-item">
        <a class="nav-link" routerLink="/" routerLinkActive="active"
           (click)="showMenuDropDown = !showMenuDropDown; showDropDown = false; homeContentRefresh(); showSearchBar=false; closeMyCart()">Menu</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/about" routerLinkActive="active"
           (click)="showMenuDropDown = !showMenuDropDown; showDropDown = false; showSearchBar=false; closeMyCart()">About</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/how-to-order" routerLinkActive="active"
           (click)="showMenuDropDown = !showMenuDropDown; showDropDown = false; showSearchBar=false; closeMyCart()">How it Works</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/faq" routerLinkActive="active"
           (click)="showMenuDropDown = !showMenuDropDown; showDropDown = false;showSearchBar=false; closeMyCart()">FAQ</a>
      </li>
    </ul>
  </div>

  <div class="headerRight">
    <img alt="Search" width="23" height="23" class="cursorPointer searchIcon" (click)="showSearch(); showMenuDropDown = false; showLoginSignupDropDown = false; showDropDown = false; closeMyCart()"
         routerLink="/search" routerLinkActive="active" src="assets/images/header-search-icon.svg">
    <div *ngIf="showSearchBar" class="searchFormBg">
      <form [formGroup]="searchForm" style="position: relative;">
        <input class="searchBox" name="searchItems" type="text" formControlName="searchItems"
               (input)="onChange($event.target.value)" tabindex="0" autocomplete="off" #searchInput autofocus>
        <span class="clearSearch" (click)="clearSearchField(); closeMyCart()" *ngIf="clearSearch">&times;</span>
        <span class="cancelBtn" (click)="cancelSearch(); closeMyCart()">Cancel</span>
      </form>
    </div>
    <div class="headerUser ml-lg-5 ml-sm-4 mr-lg-5 mr-sm-4" [ngClass]="{'displayNone' : editOrderAddingAnotherItem}">
      <img alt="User icon" *ngIf="!isLoggedIn" width="25" height="25" class="mr-2 userIcon userIconBigDevice" src="assets/images/header-user-icon.svg">
      <img alt="User icon" *ngIf="!isLoggedIn" width="25" height="25" class="mr-2 userIcon userIconSmallDevice" (click)="showLoginSignupDropDown = !showLoginSignupDropDown; showMenuDropDown = false; showSearchBar = false; closeMyCart()" src="assets/images/header-user-icon.svg">
      <div class="loginSignUpSmallDevices" *ngIf="showLoginSignupDropDown">
        <a (click)="loginModal(); showSearchBar = false; closeMyCart()">Login</a>
        <p><span>or</span></p>
        <a (click)="signupModal(); showSearchBar = false; closeMyCart()" >Sign Up</a>
      </div>
      <div *ngIf="!isLoggedIn" class="loginSignUpText">
        <a (click)="loginModal(); showSearchBar = false; closeMyCart()">Login</a>
        <span class="ml-lg-1 ml-sm-0 mr-lg-1 mr-sm-0">or</span>
        <a (click)="signupModal(); showSearchBar = false; closeMyCart()" >Sign Up</a>
      </div>
      <div *ngIf="isLoggedIn" class="position-relative" style="display: flex;">
        <img alt="User icon" *ngIf="isLoggedIn" width="25" height="25" class="mr-2 userIcon userIconBigDevice" src="assets/images/header-user-icon.svg">
        <img alt="User icon" *ngIf="isLoggedIn" width="25" height="25" class="mr-2 userIcon userIconSmallDevice" (click)="showHideDropDown(); showMenuDropDown = false; showSearchBar = false; closeMyCart()" src="assets/images/header-user-icon.svg">
        <div class="cursor-pointer userName" (click)="showHideDropDown(); showMenuDropDown = false; showSearchBar = false; closeMyCart()">
          <span class="ml-lg-1 ml-sm-0 mr-lg-1 mr-sm-0 ">{{userName}}</span>
          <i class="fa" [ngClass]="[showDropDown ? 'fa-chevron-up' : 'fa-chevron-down']" aria-hidden="true"></i>
        </div>
        <div class="drop-down-bg" *ngIf="showDropDown">
          <a class="drop-down-item w-100 pl-3 pr-3 cursor-pointer" routerLink="/user/account-info" (click)="showHideDropDown(); closeMyCart()">
            Account Info <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
          <a class="drop-down-item w-100 pl-3 pr-3 cursor-pointer" routerLink="/orders/list" (click)="showHideDropDown(); closeMyCart()">
            Orders <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
          <a class="drop-down-item w-100 pl-3 pr-3 cursor-pointer" routerLink="/payments/list" (click)="showHideDropDown(); closeMyCart()">
            Payment Method <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
          <a class="drop-down-item w-100 pl-3 pr-3 cursor-pointer" routerLink="/address-book/list" (click)="showHideDropDown(); closeMyCart()">
            Address Book <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
          <a class="drop-down-item w-100 pl-3 pr-3 cursor-pointer" (click)="logOutClick(); closeMyCart()">Log Out</a>
        </div>
      </div>
    </div>
    <div class="cart" (click)="openMyCardClick(); showMenuDropDown = false; showLoginSignupDropDown = false; showSearchBar = false; showDropDown = false;" style="cursor: pointer;" [ngClass]="{'pointer-event-none': disableCartIcon, 'displayNone' : editOrderAddingAnotherItem}">
      <span class="cart-item-count" *ngIf="totalCartItems > 0 && totalCartItems <= 999" [ngClass]="{'cartCountIndent' : totalCartItems < 100}">{{totalCartItems}}</span>
      <span class="cart-item-count" style="text-align: center;" *ngIf="totalCartItems > 999">999+</span>
      <img alt="Search" width="25" height="25" class="cursorPointer cartIcon" src="assets/images/cart/header-cart-icon.svg" *ngIf="totalCartItems <= 0">
      <img alt="Search" width="25" height="25" class="cursorPointer cartIcon" src="assets/images/cart/cart_icon_open.svg" *ngIf="totalCartItems > 0">
    </div>
  </div>

</header>



// WEBPACK FOOTER //
// ./src/app/template/header/header.component.html